import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-right: 1.5rem;

  flex: 1;

  > .MuiFormControl-root:not(:first-child) {
    margin-left: 1rem;
  }
`;
